import React, { useState, useEffect } from 'react';
import { useSelector } from "react-redux";
import axios from 'axios';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { AppRemixIcon, AppModal, AppSingleSelect, AppNotificationAlert } from '@/layout/AppComponents';
import { Formik } from 'formik';
import ReactDOMServer from 'react-dom/server';
import AppSpinner from '../../../../../components/AppSpinner';
import { axiosPath } from '../../../../../../routing/helpers/router';
import Translator from '../../../../../components/helpers/Translator';
import colors from '../../../../../../constants/colors';

const SecondStatesSelect = (props) => {
  const {
    plantObligationID, className,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const secondState = useSelector(
    (s) =>
      s.currentPage?.plantObligationLevels?.level3?.[plantObligationID]
        ?.secondState
  );
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [tempSecondState, setTempSecondState] = useState(secondState);

  useEffect(() => {
    setTempSecondState(secondState);
  }, [secondState]);

  // > CHANGE SECOND STATE
  const changeState = async (values) => {
    setOpen(false);
    setLoading(true);
    try {
      await axios.post(
        axiosPath(
          "api_r_user_module_legalCompliance_evaluation_changeSecondState"
        ),
        {
          moduleBridgeHex,
          plantHex,
          plantObligation: plantObligationID,
          state: values.state,
        }
      );
      setTempSecondState(values.state);
      setLoading(false);
      return true;
    } catch (err) {
      setLoading(false);
      AppNotificationAlert({
        title: "Error",
        message: ReactDOMServer.renderToString(
          <Translator file="module-legalCompliance" name="state.change.error" />
        ),
        type: "danger",
        position: "top-center",
        duration: 0,
      });
    }
  };
  // < CHANGE SECOND STATE
  return (
    <>
      {tempSecondState === undefined ? (
        <div
          className={`relative ${className}`}
        >
          <AppSpinner><AppRemixIcon icon="loader-4" size={30} color={colors.primaryLight} /></AppSpinner>
        </div>
      ) : (
        <div
          className={`relative pointer ${className}`}
          style={{ backgroundColor: (!tempSecondState) ? 'grey' : (tempSecondState === 1 ? 'green' : 'red') }}
          title={!tempSecondState ? ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="no.reviewed" />) : (tempSecondState === 1 ? ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="satisfied" />) : ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="no.satisfied" />))}
          onClick={() => setOpen(true)}
        >
          {!loading
            ? <AppRemixIcon icon="lightbulb" color="white" filled />
            : <AppSpinner><AppRemixIcon icon="loader-4" size={30} color="white" /></AppSpinner>}
          <StateSelectExpand />
        </div>
      )}

      <AppModal
        show={!!open}
        onClose={() => setOpen(false)}
      >
        <Formik
          validateOnChange={false}
          validateOnBlur={false}
          enableReinitialize
          initialValues={{
            state: tempSecondState || 0,
          }}
          onSubmit={changeState}
        >
          {({
            setFieldValue, handleSubmit, values, isSubmitting,
          }) => (
            <>
              <AppSingleSelect
                title={ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="module.lc.blockChange.select" />)}
                options={[
                  { label: ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="no.reviewed" />), value: 0 },
                  { label: ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="satisfied" />), value: 1 },
                  { label: ReactDOMServer.renderToString(<Translator file="module-legalCompliance" name="no.satisfied" />), value: 2 },
                ]}
                icon={<AppRemixIcon icon="list-check" noVariants />}
                onChange={(v) => setFieldValue('state', v)}
                value={values.state}
              />
              <span
                className="btn btn-success float-right mt-3"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                <Translator file="general" name="general.update" />
              </span>
            </>
          )}
        </Formik>
      </AppModal>
    </>
  );
};

export default SecondStatesSelect;

const StateSelectExpand = styled.div`
  width: 0;
  overflow: hidden;
  position: absolute;
  top: 3px;
  left: 42px;
  height: 154px;
  z-index: 10;
  transition: width ease 0.4s;
  font-size: 14px;
  background: white;
`;
